import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import settings from "src/devices/all/settings";

class WorkflowTask extends AbstractRequestTask {
    constructor(params = {
        groupId: "",
        offerId: "",
        linkworkflowstartParams: {},
        validateLogin: false,
    }) {
        super();

        this.groupId = params.groupId;
        this.offerId = params.offerId;
        this.linkworkflowstartParams = params.linkworkflowstartParams;
        this.validateLogin = params.validateLogin || false;
    }

    getHeaders() {
        const params = super.getParams();
        return {
            'Content-Type': 'application/json',
            'user-token': params.user_token
        };
    }

    getUrl() {
        if(settings.fake_url_mockoon) {
            return `${settings.fake_url_mockoon}/services/payway/workflowstart`;
          }
          else {
            const http = "https://";
            const url = Launcher.get("akamai_mfwk");
            return `${http}${url}/services/payway/v1/workflowstart`;
          } 

        
    }

    getParams() {

        const params = super.getParams();
        delete params.HKS;
        delete params.user_token;
        delete params.api_version;       
        if (this.groupId === undefined) {
            //suscripcion desde registro                
            console.log(this.linkworkflowstartParams);
            return {
                ...this.linkworkflowstartParams,
                ...params,
                validatelogin: this.validateLogin,
            };
        }
        else {            
            return {
                offer_id: this.offerId,
                object_type: "G",
                ...this.linkworkflowstartParams,
                ...params,
                validatelogin: this.validateLogin,
            };
        }
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default WorkflowTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/WorkFlowStartTask.js